import { supabase } from '../lib/supabaseClient';

export async function cleanDuplicateUsers() {
  console.log('🧹 Starting duplicate user cleanup...');
  
  try {
    // Get all profiles
    const { data: profiles, error: profilesError } = await supabase
      .from('profiles')
      .select('id, email, full_name, role, created_at')
      .order('created_at', { ascending: true }); // Oldest first
    
    if (profilesError) {
      console.error('❌ Error fetching profiles:', profilesError);
      return;
    }
    
    console.log('📊 Total profiles found:', profiles?.length || 0);
    
    // Group by email
    const emailGroups = new Map();
    profiles?.forEach(profile => {
      if (profile.email) {
        if (!emailGroups.has(profile.email)) {
          emailGroups.set(profile.email, []);
        }
        emailGroups.get(profile.email).push(profile);
      }
    });
    
    // Find duplicates
    const duplicateGroups = Array.from(emailGroups.entries())
      .filter(([_, profiles]) => profiles.length > 1);
    
    if (duplicateGroups.length === 0) {
      console.log('✅ No duplicate users found');
      return;
    }
    
    console.log(`⚠️  Found ${duplicateGroups.length} emails with duplicates:`);
    
    const idsToDelete: string[] = [];
    
    duplicateGroups.forEach(([email, duplicates]) => {
      console.log(`\n📧 Email: ${email} (${duplicates.length} duplicates)`);
      
      // Sort by created_at to keep the oldest one
      duplicates.sort((a: any, b: any) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
      
      const keepProfile = duplicates[0]; // Keep the oldest
      const deleteProfiles = duplicates.slice(1); // Delete the rest
      
      console.log(`   ✅ Keeping: ${keepProfile.id} (created: ${keepProfile.created_at})`);
      
      deleteProfiles.forEach((profile: any) => {
        console.log(`   ❌ Will delete: ${profile.id} (created: ${profile.created_at})`);
        idsToDelete.push(profile.id);
      });
    });
    
    if (idsToDelete.length > 0) {
      console.log(`\n🗑️  About to delete ${idsToDelete.length} duplicate profiles`);
      console.log('IDs to delete:', idsToDelete);
      
      // Uncomment the following lines to actually perform the deletion
      // WARNING: This will permanently delete data!
      
      /*
      const { error: deleteError } = await supabase
        .from('profiles')
        .delete()
        .in('id', idsToDelete);
      
      if (deleteError) {
        console.error('❌ Error deleting duplicates:', deleteError);
      } else {
        console.log('✅ Successfully deleted duplicate profiles');
      }
      */
      
      console.log('⚠️  Deletion is commented out for safety. Uncomment the deletion code to proceed.');
    }
    
  } catch (error) {
    console.error('❌ Error during cleanup:', error);
  }
}

// Function to run the cleanup (can be called from browser console)
(window as any).cleanDuplicateUsers = cleanDuplicateUsers;